/**
 *
 * Question
 *
 */

import { mapState, mapGetters, mapMutations } from 'vuex';

export const QaQuestionFeedbackMixin = {
  name: 'QaQuestionFeedbackMixin',

  props: {
    p_objQa: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapState('QA/Question', {
      ms_qaQuestion: 'qaQuestion',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isCanFeedback() {
      return (
        this.mg_userInfo.isCurrentStudent &&
        this.ms_qaQuestion.isMyQuestion &&
        (this.p_objQa.qaRole == 2 || this.p_objQa.qaRole == 3) &&
        !this.p_objQa.isFeedback
      );
    },
  },

  methods: {
    ...mapMutations('QA/Question', {
      mm_UPDATE_QA_ANSWER: 'UPDATE_QA_ANSWER',
    }),

    toggleFeedback() {
      this.mm_UPDATE_QA_ANSWER({
        ...this.p_objQa,
        i_feedbackIsOpen: !this.p_objQa.i_feedbackIsOpen,
      });
    },
  },
};
